import gfoxgif from "../../assets/images/gfoxgif.gif";
import fox4 from "../../assets/images/arts/fox4.jpg";
import FlareIcon from '@material-ui/icons/Flare';

const SectionTwoImg = () => {
    return (
        <div className="bg-cn text-center" id="play">
            <div className="container"  data-aos="fade-up" 
            data-aos-offset="600"
            
            >
                <div className="row py-5 ply-round">
                    <div className="col-12 pb-3">
                    <h1 className="sec-heading py-md-0 pt-2 text-center text-white">Play</h1>
                    <h4 className="py-3 text-white text-center">
                    Stake your G-Fox to begin hunting Bounty.
                    </h4>
                    </div>
                    <div className="col-md-4 text-center">
                        <img 
                         data-aos="fade-right" data-aos-delay="100"
                        className="img-fluid rounded-i animat-img" src={gfoxgif} alt="G Fox" />
                    </div>
                    <div className="col-md-4 col-12 text-center center-btn-wrap my-md-0 my-5">
                        <div className="claim-wrapp">
                            <span className="score text-white">0.000000000 Bounty</span>
                            <button className="claim-btn">CLAIM</button>
                        </div>
                        <div className="my-auto">
                        <button className="start-mission-btn">
                            START MISSION &nbsp; <FlareIcon/>
                        </button>
                        {/* <button className="start-mission-btn op-btn">
                            START MISSION 2 &nbsp; <FlareIcon/>
                        </button> */}
                      
                        </div>
                        <button disabled className="start-mission-btn mt-auto op-btn">
                            START Building  &nbsp; <FlareIcon/>
                        </button>
                    </div>
                    <div className="col-md-4 text-center"  data-aos="fade-left" data-aos-delay="100">
                        <img className="img-fluid rounded-i animat-img" src={fox4} alt="G Fox" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionTwoImg
